export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: string; output: string; }
};

export type NotificationPreferenceInput = {
  categoryKey: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
};

export type PartnerUserInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  partnerIdentifier: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  regionIdentifier?: InputMaybe<Scalars['String']['input']>;
  roles: Array<Scalars['String']['input']>;
};

export enum ReferralState {
  LEAD_DENIED = 'LEAD_DENIED',
  LEAD_QUALIFIED = 'LEAD_QUALIFIED',
  LEAD_SELLER_FLOW_INCOMPLETE = 'LEAD_SELLER_FLOW_INCOMPLETE',
  OFFER_ACCEPTED = 'OFFER_ACCEPTED',
  OFFER_ASSESSMENTS_COMPLETED = 'OFFER_ASSESSMENTS_COMPLETED',
  OFFER_CLOSED = 'OFFER_CLOSED',
  OFFER_CONTINGENCIES_RELEASED = 'OFFER_CONTINGENCIES_RELEASED',
  OFFER_EXPIRED = 'OFFER_EXPIRED',
  OFFER_EXPIRING_SOON = 'OFFER_EXPIRING_SOON',
  OFFER_FINAL_OFFER_UNRELEASED = 'OFFER_FINAL_OFFER_UNRELEASED',
  OFFER_IN_CONTRACT = 'OFFER_IN_CONTRACT',
  OFFER_REJECTED = 'OFFER_REJECTED',
  OFFER_SENT = 'OFFER_SENT',
  OFFER_VIEWED = 'OFFER_VIEWED',
  OFFER_WITHDRAWN = 'OFFER_WITHDRAWN',
  UNKNOWN = 'UNKNOWN'
}

export type SearchReferralsInput = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  state?: InputMaybe<ReferralState>;
};

export enum SlackChannel {
  SIGN_UP = 'SIGN_UP'
}

export type SlackMessageField = {
  title: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export enum TourRequestState {
  CANCELED = 'CANCELED',
  COMPLETE = 'COMPLETE',
  NO_SHOW = 'NO_SHOW',
  REQUESTED = 'REQUESTED',
  SCHEDULED = 'SCHEDULED'
}

export type UpdateUserNotificationPreferencesInput = {
  notificationPreferences: Array<NotificationPreferenceInput>;
  userId?: InputMaybe<Scalars['String']['input']>;
};
